// storage.js
if (typeof window !== 'undefined') {
  window.medianLibraryReady = false;
}

window.median_library_ready = function() {
  if (typeof window !== 'undefined') {
    window.medianLibraryReady = true;
  }
};

if (typeof window !== 'undefined' && window.median) {
  window.median_library_ready();
}

export const storage = {
  async setItem(key, value) {
    try {
      // Завжди зберігаємо в localStorage
      localStorage.setItem(key, value);

      // Додатково зберігаємо в Median App Storage
      if (typeof window !== 'undefined' && window.median?.storage?.app) {
        try {
          await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
              resolve(); // Не блокуємо, просто продовжуємо
            }, 2000);

            window.median.storage.app.set({
              key: key,
              value: value,
              statuscallback: (result) => {
                clearTimeout(timeout);
                console.log('[Storage] Median saved:', key, result);
                resolve();
              }
            });
          });
        } catch (error) {
          console.warn('[Storage] Median set ERROR:', error);
        }
      }
    } catch (error) {
      console.error('[Storage] setItem error:', error);
    }

    return Promise.resolve();
  },

  async getItem(key) {
    // console.log('[Storage] Getting item:', key);

    try {
      // Спочатку перевіряємо localStorage
      let value = localStorage.getItem(key);

      if (value) {
        // console.log('[Storage] Found in localStorage:', key);
        return value;
      }

      // Якщо в localStorage порожньо - пробуємо Median storage
      if (typeof window !== 'undefined' && window.median?.storage?.app) {
        try {
          const result = await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
              console.warn('[Storage] Median get timeout');
              resolve(null);
            }, 2000);

            window.median.storage.app.get({
              key: key,
              callback: (result) => {
                clearTimeout(timeout);
                resolve(result);
              }
            });
          });

          if (result?.status === 'success' && result.data) {
            // console.log('[Storage] Found in Median:', key);
            // Синхронізуємо з localStorage
            localStorage.setItem(key, result.data);
            return result.data;
          }
        } catch (error) {
          console.warn('[Storage] Median get ERROR:', error);
        }
      }

      // Остання спроба з localStorage
      value = localStorage.getItem(key);
      // console.log('[Storage] Final result for', key, ':', !!value);
      return value;
    } catch (error) {
      console.error('[Storage] getItem error:', error);
      return null;
    }
  },

  async removeItem(key) {
    // console.log('[Storage] Removing item:', key);

    try {
      // Видаляємо з localStorage
      localStorage.removeItem(key);
      // console.log('[Storage] Removed from localStorage:', key);

      // Додатково видаляємо з Median App Storage
      if (typeof window !== 'undefined' && window.median?.storage?.app) {
        try {
          await new Promise((resolve) => {
            const timeout = setTimeout(() => {
              console.warn('[Storage] Median delete timeout');
              resolve();
            }, 2000);

            window.median.storage.app.delete({
              key: key,
              statuscallback: (result) => {
                clearTimeout(timeout);
                // console.log('[Storage] Median deleted:', key, result);
                resolve();
              }
            });
          });
        } catch (error) {
          console.warn('[Storage] Median delete ERROR:', error);
        }
      }
    } catch (error) {
      console.error('[Storage] removeItem error:', error);
    }

    return Promise.resolve();
  }
};
